// Mark every chat_mention for the caller in the given channel as read.
// Backed by the chat_mark_mentions_read SQL function from
// 0015_chat_thread_count_and_mentions_index.sql, which does the join +
// update server-side and returns the count it touched.
import { getSDK } from '../sdk.js'

export const markMentionsRead = async function (channelId) {
  if (!channelId) return 0
  const root = this.state.root
  const me = root.currentUserEmail
  const msgIds = new Set(((root.messagesByChannel || {})[channelId] || []).map(m => m.id))
  // Early-return if there's nothing to clear in this channel — avoids
  // a useless state write + RPC round-trip on every channel switch.
  const unread = (root.myMentions || []).filter(m => msgIds.has(m.message_id) && !m.read_at)
  if (unread.length === 0) return 0
  const now = new Date().toISOString()
  root.update({
    myMentions: (root.myMentions || []).map(m =>
      msgIds.has(m.message_id) && !m.read_at ? { ...m, read_at: now } : m
    )
  })
  try {
    // migrated 2026-04-27 to SDK route workspaceProject.chat.mentions markRead
    const result = await getSDK().execute('workspaceProject.chat.mentions', 'markRead', {
      channelId,
      callerEmail: me
    })
    return result?.data ?? result ?? 0
  } catch (e) {
    console.error('[markMentionsRead]', e?.message || e)
    return 0
  }
}
